<template>
  <AboutMenu :menu="lang == 'zh' ? menu : enMenu" />
</template>

<script>
import AboutMenu from "@/views/components/AboutMenu";

export default {
  data() {
    return {
      lang: this.$global.lang,
      menu: [
        { name: "公司介绍", url: "/about/my" },
        { name: "企业文化", url: "/culture" },
        { name: "公司领导", url: "/leaders" },
        { name: "公司治理", url: "/manager" },
        { name: "发展历程", url: "/development" },
        { name: "荣誉信誉", url: "/honor" },
        { name: "联系我们", url: "/contact" },
      ],
      enMenu: [
        { name: "BRIEF INTRODUCTION", url: "/about/my" },
        { name: "CORPORATE CULTURE", url: "/about/culture" },
        { name: "MANAGEMENT", url: "/leaders" },
        { name: "DEVELOPMENT HISTORY", url: "/development" },
         { name: "DEVELOPMENT PLAN", url: "/developmentplan" },
      ],
    };
  },
  props: ["menus"],
  components: {
    AboutMenu,
  },
};
</script>